export const ACCOUNT_DELETION_REQUEST_STATUSES = [
  'pending',
  'processing',
  'completed',
  'failed',
] as const;

export type AccountDeletionRequestStatus =
  (typeof ACCOUNT_DELETION_REQUEST_STATUSES)[number];

export const ACCOUNT_DELETION_REQUEST_PLATFORMS = [
  'ios',
  'android',
  'web',
] as const;

export type AccountDeletionRequestPlatform =
  (typeof ACCOUNT_DELETION_REQUEST_PLATFORMS)[number];

export const ACCOUNT_DELETION_REASONS = [
  'too_many_notifications',
  'privacy_concern',
  'not_useful',
  'found_job',
  'cost',
  'other',
] as const;

export type AccountDeletionReason = (typeof ACCOUNT_DELETION_REASONS)[number];

export type AccountDeletionRequestMetadataValue =
  | string
  | number
  | boolean
  | null;

export interface CreateAccountDeletionRequestInput {
  reasonCategory: AccountDeletionReason;
  reason?: string;
  route?: string;
  platform: AccountDeletionRequestPlatform;
  appVersion?: string;
  locale?: string;
  metadata?: Record<string, AccountDeletionRequestMetadataValue>;
}

export interface UserAccountDeletionRequestSummary {
  id: string;
  userId: string;
  reasonCategory: AccountDeletionReason;
  reason: string | null;
  route: string | null;
  platform: AccountDeletionRequestPlatform;
  appVersion: string | null;
  locale: string | null;
  status: AccountDeletionRequestStatus;
  createdAt: string;
  updatedAt: string;
  /**
   * The durable deletion receipt (audit E10): a random id the person can
   * quote to support. Null when the receipt could not be stored (the
   * deletion itself still completed). Absent from servers before E10.
   */
  receiptId?: string | null;
}
